/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

// Copying the same url regex store uses in order to match their validation behavior.
export const HTTP_URL_REGEX =
  "^https?:\\/\\/[a-zA-Z0-9-._~:\\/?#\\[\\]@!$&'()*\\+,;=%]+$";

export const ColumnDirections = {
  ASC: 'ASC',
  DESC: 'DESC',
  NONE: 'NONE'
};

export const ROWS_PER_PAGE_DEFAULT = 50;
export const ROWS_PER_PAGE_OPTIONS = [25, 50, 75, 100];

export const ELSER_MODELS = {
  elser_model_1: {
    id: '.elser_model_1',
    queryBody: {
      query: {
        nested: {
          path: 'passages',
          query: {
            bool: {
              filter: '$FILTER',
              should: [
                {
                  text_expansion: {
                    'passages.sparse.tokens': {
                      model_id: '.elser_model_1',
                      model_text: '$QUERY'
                    }
                  }
                }
              ]
            }
          },
          inner_hits: { _source: { excludes: ['passages.sparse'] } }
        }
      },
      _source: false
    }
  },
  elser_model_2: {
    id: '.elser_model_2',
    queryBody: {
      query: {
        nested: {
          path: 'passages',
          query: {
            bool: {
              filter: '$FILTER',
              should: [
                {
                  text_expansion: {
                    'passages.sparse.tokens': {
                      model_id: '.elser_model_2',
                      model_text: '$QUERY'
                    }
                  }
                }
              ]
            }
          },
          inner_hits: { _source: { excludes: ['passages.sparse'] } }
        }
      },
      _source: false
    }
  },
  'elser_model_2_linux-x86_64': {
    id: '.elser_model_2_linux-x86_64',
    queryBody: {
      query: {
        nested: {
          path: 'passages',
          query: {
            bool: {
              filter: '$FILTER',
              should: [
                {
                  text_expansion: {
                    'passages.sparse.tokens': {
                      model_id: '.elser_model_2_linux-x86_64',
                      model_text: '$QUERY'
                    }
                  }
                }
              ]
            }
          },
          inner_hits: { _source: { excludes: ['passages.sparse'] } }
        }
      },
      _source: false
    }
  }
};
